export default "__VITE_ASSET__BI7nzhDX__";